module.exports = __webpack_public_path__ + "static/media/First.600f1d87.svg";